import { render, staticRenderFns } from "./AppBanner.vue?vue&type=template&id=746b64d0&scoped=true&"
import script from "./AppBanner.vue?vue&type=script&lang=js&"
export * from "./AppBanner.vue?vue&type=script&lang=js&"
import style0 from "./AppBanner.vue?vue&type=style&index=0&id=746b64d0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "746b64d0",
  null
  
)

export default component.exports